import { module } from 'modujs';
import { html } from '../utils/environment';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {

    }

    trigger(e) {
        
        // data-module-theme="uID" data-scroll="item" data-scroll-repeat data-scroll-call="trigger,Theme, uID" 
        // data-theme-top="light" data-theme-bottom="dark"

        let themes = [e.$el.getAttribute('data-theme-top'), e.$el.getAttribute('data-theme-bottom')];
        
        if(window.scrollInstance != undefined) {
            if(e.mode === 'enter' && window.scrollInstance.direction == 'down') {
                html.dataset.theme = themes[1];
            }
            if(e.mode === 'leave' && window.scrollInstance.direction == 'up') {
                html.dataset.theme = themes[0];
            }
        } else {
            if(e.mode === 'enter') {
                html.dataset.theme = themes[1];
            }
        }

        // if(html.getAttribute('data-theme') == 'light') {
        //     document.querySelector('meta[name="theme-color"]').setAttribute('content',  '#3A4638');
        // } else if(html.getAttribute('data-theme') == 'dark'){
        //     document.querySelector('meta[name="theme-color"]').setAttribute('content',  '#E29473');
        // } else if(html.getAttribute('data-theme') == 'pink'){
        //     document.querySelector('meta[name="theme-color"]').setAttribute('content',  '#E7BEAF');
        // }
    }
}
